/**
 * External dependencies
 */
import Global from '@naruto/naruto-reducers/src/stores/global';
import Message from '@naruto/naruto-reducers/src/stores/message';

/**
 * Internal dependencies
 */
import User from '@naruto/bgdapp/src/reducers/stores/user';
import Project from '@naruto/bgdapp/src/reducers/stores/project';
import Service from '@naruto/bgdapp/src/reducers/stores/service';
import Contact from '@naruto/bgdapp/src/reducers/stores/contact';
import SiteMeta from '@naruto/bgdapp/src/reducers/stores/site-meta';
import { Models } from './types';

function initialModel(): Models {
  const model: Models = {
    /* Shared Reducer */
    global: new Global(),
    message: new Message(),
    user: new User(),
    /* App Reducer */
    project: new Project(),
    service: new Service(),
    contact: new Contact(),
    siteMeta: new SiteMeta()
  };
  return model;
}

export default initialModel;
